import { ResourceOptions } from 'react-admin';
import { MdHistory } from 'react-icons/md';
import { Resources } from '../../resource';

export { default as list } from './List';

export const name = Resources.xbitRelaySweepHistory;
export { XBIT_RELAY_SWEEP_HISTORY_PERMISSION_RESOURCE } from './constants';
export const icon = MdHistory;
export const options: ResourceOptions = {
  label: 'module.xbitRelaySweepHistory.title',
};
